import { debounce } from '@lhb/func';
import { useEffect, useState } from 'react';
import { getResList } from '@/api/place';


function useReourcePlace (id: string, isStringValue = false): { onSearch: (value: string) => void, options: ({ label: string, value: any })[] } {
  const [options, setOptions] = useState<any[]>([]);

  const searchLabel = async (searchPlaceName: string) => {
    const { objectList } = await getResList(1, 10, { searchPlaceName });
    if (objectList) {
      const options = objectList.map((item: any) => {
        return { label: item.name, value: isStringValue ? String(item.id) : item.id };
      });
      setOptions(options);
    }
  };

  const onSearch = (value) => {
    const newFn = debounce(searchLabel, 500);
    newFn(value);
  };

  useEffect(() => {
    searchLabel('');
  }, [id]);

  return {
    onSearch,
    options
  };
};

export default useReourcePlace;
